export const castToUnion = <T>(value: unknown, options: T[]): T | undefined =>
    value && options.some((cur) => cur === value) ? (value as T) : undefined;
